import { render } from "./DocumentsDansukAR.vue?vue&type=template&id=5f119dca&scoped=true"
import script from "./DocumentsDansukAR.vue?vue&type=script&lang=js"
export * from "./DocumentsDansukAR.vue?vue&type=script&lang=js"

import "./DocumentsDansukAR.vue?vue&type=style&index=0&id=5f119dca&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f119dca"]])

export default __exports__